export default {"src":"/_next/static/media/0x947950bcc74888a40ffa2593c5798f11fc9124c4.6d8b1f8f.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};